import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/esnext.string.replace-all.js";
import { proxy as m, subscribe as f, snapshot as $ } from "valtio/vanilla";
import { Buffer as V } from "buffer";
var N;
var C = {
    ethereumClient: void 0,
    setEthereumClient: function setEthereumClient(e) {
      N = e;
    },
    client: function client() {
      if (N) return N;
      throw new Error("ClientCtrl has no client set");
    }
  },
  i = m({
    history: ["ConnectWallet"],
    view: "ConnectWallet",
    data: void 0
  }),
  b = {
    state: i,
    subscribe: function subscribe(e) {
      return f(i, function () {
        return e(i);
      });
    },
    push: function push(e, t) {
      e !== i.view && (i.view = e, t && (i.data = t), i.history.push(e));
    },
    reset: function reset(e) {
      i.view = e, i.history = [e];
    },
    replace: function replace(e) {
      i.history.length > 1 && (i.history[i.history.length - 1] = e, i.view = e);
    },
    goBack: function goBack() {
      if (i.history.length > 1) {
        i.history.pop();
        var _i$history$slice = i.history.slice(-1),
          _i$history$slice2 = _slicedToArray(_i$history$slice, 1),
          e = _i$history$slice2[0];
        i.view = e;
      }
    },
    setData: function setData(e) {
      i.data = e;
    }
  },
  c = {
    WALLETCONNECT_DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
    W3M_VERSION: "W3M_VERSION",
    W3M_PREFER_INJECTED_URL_FLAG: "w3mPreferInjected",
    RECOMMENDED_WALLET_AMOUNT: 9,
    isMobile: function isMobile() {
      return typeof window < "u" ? !!(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/.test(navigator.userAgent)) : !1;
    },
    isAndroid: function isAndroid() {
      return c.isMobile() && navigator.userAgent.toLowerCase().includes("android");
    },
    isIos: function isIos() {
      var e = navigator.userAgent.toLowerCase();
      return c.isMobile() && (e.includes("iphone") || e.includes("ipad"));
    },
    isHttpUrl: function isHttpUrl(e) {
      return e.startsWith("http://") || e.startsWith("https://");
    },
    isArray: function isArray(e) {
      return Array.isArray(e) && e.length > 0;
    },
    formatNativeUrl: function formatNativeUrl(e, t, n) {
      if (c.isHttpUrl(e)) return this.formatUniversalUrl(e, t, n);
      var s = e;
      s.includes("://") || (s = e.replaceAll("/", "").replaceAll(":", ""), s = "".concat(s, "://")), this.setWalletConnectDeepLink(s, n);
      var a = encodeURIComponent(t);
      return "".concat(s, "wc?uri=").concat(a);
    },
    formatUniversalUrl: function formatUniversalUrl(e, t, n) {
      if (!c.isHttpUrl(e)) return this.formatNativeUrl(e, t, n);
      var s = e;
      e.endsWith("/") && (s = e.slice(0, -1)), this.setWalletConnectDeepLink(s, n);
      var a = encodeURIComponent(t);
      return "".concat(s, "/wc?uri=").concat(a);
    },
    wait: function wait(e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (t) {
                setTimeout(t, e);
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openHref: function openHref(e, t) {
      window.open(e, t, "noreferrer noopener");
    },
    setWalletConnectDeepLink: function setWalletConnectDeepLink(e, t) {
      localStorage.setItem(c.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
        href: e,
        name: t
      }));
    },
    setWalletConnectAndroidDeepLink: function setWalletConnectAndroidDeepLink(e) {
      var _e$split = e.split("?"),
        _e$split2 = _slicedToArray(_e$split, 1),
        t = _e$split2[0];
      localStorage.setItem(c.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
        href: t,
        name: "Android"
      }));
    },
    removeWalletConnectDeepLink: function removeWalletConnectDeepLink() {
      localStorage.removeItem(c.WALLETCONNECT_DEEPLINK_CHOICE);
    },
    setWeb3ModalVersionInStorage: function setWeb3ModalVersionInStorage() {
      typeof localStorage < "u" && localStorage.setItem(c.W3M_VERSION, "2.4.2-3d672481");
    },
    getWalletRouterData: function getWalletRouterData() {
      var e;
      var t = (e = b.state.data) == null ? void 0 : e.Wallet;
      if (!t) throw new Error('Missing "Wallet" view data');
      return t;
    },
    getSwitchNetworkRouterData: function getSwitchNetworkRouterData() {
      var e;
      var t = (e = b.state.data) == null ? void 0 : e.SwitchNetwork;
      if (!t) throw new Error('Missing "SwitchNetwork" view data');
      return t;
    },
    isPreferInjectedFlag: function isPreferInjectedFlag() {
      return typeof location < "u" ? new URLSearchParams(location.search).has(c.W3M_PREFER_INJECTED_URL_FLAG) : !1;
    }
  },
  B = typeof location < "u" && (location.hostname.includes("localhost") || location.protocol.includes("https")),
  u = m({
    enabled: B,
    userSessionId: "",
    events: [],
    connectedWalletId: void 0
  }),
  H = {
    state: u,
    subscribe: function subscribe(e) {
      return f(u.events, function () {
        return e($(u.events[u.events.length - 1]));
      });
    },
    initialize: function initialize() {
      u.enabled && typeof crypto < "u" && (u.userSessionId = crypto.randomUUID());
    },
    setConnectedWalletId: function setConnectedWalletId(e) {
      u.connectedWalletId = e;
    },
    click: function click(e) {
      if (u.enabled) {
        var t = {
          type: "CLICK",
          name: e.name,
          userSessionId: u.userSessionId,
          timestamp: Date.now(),
          data: e
        };
        u.events.push(t);
      }
    },
    track: function track(e) {
      if (u.enabled) {
        var t = {
          type: "TRACK",
          name: e.name,
          userSessionId: u.userSessionId,
          timestamp: Date.now(),
          data: e
        };
        u.events.push(t);
      }
    },
    view: function view(e) {
      if (u.enabled) {
        var t = {
          type: "VIEW",
          name: e.name,
          userSessionId: u.userSessionId,
          timestamp: Date.now(),
          data: e
        };
        u.events.push(t);
      }
    }
  },
  l = m({
    selectedChain: void 0,
    chains: void 0,
    standaloneChains: void 0,
    standaloneUri: void 0,
    isStandalone: !1,
    isAuth: !1,
    isCustomDesktop: !1,
    isCustomMobile: !1,
    isDataLoaded: !1,
    isUiLoaded: !1,
    isPreferInjected: !1,
    walletConnectVersion: 1
  }),
  d = {
    state: l,
    subscribe: function subscribe(e) {
      return f(l, function () {
        return e(l);
      });
    },
    setChains: function setChains(e) {
      l.chains = e;
    },
    setStandaloneChains: function setStandaloneChains(e) {
      l.standaloneChains = e;
    },
    setStandaloneUri: function setStandaloneUri(e) {
      l.standaloneUri = e;
    },
    getSelectedChain: function getSelectedChain() {
      var e = C.client().getNetwork().chain;
      return e && (l.selectedChain = e), l.selectedChain;
    },
    setSelectedChain: function setSelectedChain(e) {
      l.selectedChain = e;
    },
    setIsStandalone: function setIsStandalone(e) {
      l.isStandalone = e;
    },
    setIsCustomDesktop: function setIsCustomDesktop(e) {
      l.isCustomDesktop = e;
    },
    setIsCustomMobile: function setIsCustomMobile(e) {
      l.isCustomMobile = e;
    },
    setIsDataLoaded: function setIsDataLoaded(e) {
      l.isDataLoaded = e;
    },
    setIsUiLoaded: function setIsUiLoaded(e) {
      l.isUiLoaded = e;
    },
    setWalletConnectVersion: function setWalletConnectVersion(e) {
      l.walletConnectVersion = e;
    },
    setIsPreferInjected: function setIsPreferInjected(e) {
      l.isPreferInjected = e;
    },
    setIsAuth: function setIsAuth(e) {
      l.isAuth = e;
    }
  },
  O = m({
    projectId: "",
    mobileWallets: void 0,
    desktopWallets: void 0,
    walletImages: void 0,
    chainImages: void 0,
    tokenImages: void 0,
    tokenContracts: void 0,
    standaloneChains: void 0,
    enableStandaloneMode: !1,
    enableAuthMode: !1,
    enableNetworkView: !1,
    enableAccountView: !0,
    enableExplorer: !0,
    defaultChain: void 0,
    explorerExcludedWalletIds: void 0,
    explorerRecommendedWalletIds: void 0,
    termsOfServiceUrl: void 0,
    privacyPolicyUrl: void 0
  }),
  y = {
    state: O,
    subscribe: function subscribe(e) {
      return f(O, function () {
        return e(O);
      });
    },
    setConfig: function setConfig(e) {
      var t, n, s, a;
      H.initialize(), d.setStandaloneChains(e.standaloneChains), d.setIsStandalone(!!((t = e.standaloneChains) != null && t.length) || !!e.enableStandaloneMode), d.setIsAuth(!!e.enableAuthMode), d.setIsCustomMobile(!!((n = e.mobileWallets) != null && n.length)), d.setIsCustomDesktop(!!((s = e.desktopWallets) != null && s.length)), d.setWalletConnectVersion((a = e.walletConnectVersion) != null ? a : 1), d.state.isStandalone || (d.setChains(C.client().chains), d.setIsPreferInjected(C.client().isInjectedProviderInstalled() && c.isPreferInjectedFlag())), e.defaultChain && d.setSelectedChain(e.defaultChain), c.setWeb3ModalVersionInStorage(), Object.assign(O, e);
    }
  },
  o = m({
    address: void 0,
    profileName: void 0,
    profileAvatar: void 0,
    profileLoading: !1,
    balanceLoading: !1,
    balance: void 0,
    isConnected: !1
  }),
  K = {
    state: o,
    subscribe: function subscribe(e) {
      return f(o, function () {
        return e(o);
      });
    },
    getAccount: function getAccount() {
      var e = C.client().getAccount();
      o.address = e.address, o.isConnected = e.isConnected;
    },
    fetchProfile: function fetchProfile(e, t) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var n, s, a, r, p;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              o.profileLoading = !0;
              s = t !== null && t !== void 0 ? t : o.address, a = (n = d.state.chains) == null ? void 0 : n.find(function (r) {
                return r.id === 1;
              });
              if (!(s && a)) {
                _context2.next = 17;
                break;
              }
              _context2.next = 6;
              return C.client().fetchEnsName({
                address: s,
                chainId: 1
              });
            case 6:
              r = _context2.sent;
              if (!r) {
                _context2.next = 16;
                break;
              }
              _context2.next = 10;
              return C.client().fetchEnsAvatar({
                name: r,
                chainId: 1
              });
            case 10:
              p = _context2.sent;
              _context2.t0 = p;
              if (!_context2.t0) {
                _context2.next = 15;
                break;
              }
              _context2.next = 15;
              return e(p);
            case 15:
              o.profileAvatar = p;
            case 16:
              o.profileName = r;
            case 17:
              _context2.prev = 17;
              o.profileLoading = !1;
              return _context2.finish(17);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0,, 17, 20]]);
      }))();
    },
    fetchBalance: function fetchBalance(e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _C$client$getNetwork, t, n, s, a, r;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _C$client$getNetwork = C.client().getNetwork(), t = _C$client$getNetwork.chain, n = y.state.tokenContracts;
              t && n && (s = n[t.id]), o.balanceLoading = !0;
              a = e !== null && e !== void 0 ? e : o.address;
              if (!a) {
                _context3.next = 9;
                break;
              }
              _context3.next = 7;
              return C.client().fetchBalance({
                address: a,
                token: s
              });
            case 7:
              r = _context3.sent;
              o.balance = {
                amount: r.formatted,
                symbol: r.symbol
              };
            case 9:
              _context3.prev = 9;
              o.balanceLoading = !1;
              return _context3.finish(9);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0,, 9, 12]]);
      }))();
    },
    setAddress: function setAddress(e) {
      o.address = e;
    },
    setIsConnected: function setIsConnected(e) {
      o.isConnected = e;
    },
    resetBalance: function resetBalance() {
      o.balance = void 0;
    },
    resetAccount: function resetAccount() {
      o.address = void 0, o.isConnected = !1, o.profileName = void 0, o.profileAvatar = void 0, o.balance = void 0;
    }
  },
  M = "https://explorer-api.walletconnect.com";
function U(_x, _x2) {
  return _U.apply(this, arguments);
}
function _U() {
  _U = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e, t) {
    var n;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          n = new URL(e, M);
          n.searchParams.append("projectId", y.state.projectId);
          Object.entries(t).forEach(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              s = _ref4[0],
              a = _ref4[1];
            a && n.searchParams.append(s, String(a));
          });
          _context12.next = 5;
          return fetch(n);
        case 5:
          return _context12.abrupt("return", _context12.sent.json());
        case 6:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _U.apply(this, arguments);
}
var I = {
  getDesktopListings: function getDesktopListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", U("/w3m/v1/getDesktopListings", e));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  getMobileListings: function getMobileListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", U("/w3m/v1/getMobileListings", e));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  getInjectedListings: function getInjectedListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", U("/w3m/v1/getInjectedListings", e));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  getAllListings: function getAllListings(e) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", U("/w3m/v1/getAllListings", e));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  getWalletImageUrl: function getWalletImageUrl(e) {
    return "".concat(M, "/w3m/v1/getWalletImage/").concat(e, "?projectId=").concat(y.state.projectId);
  },
  getAssetImageUrl: function getAssetImageUrl(e) {
    return "".concat(M, "/w3m/v1/getAssetImage/").concat(e, "?projectId=").concat(y.state.projectId);
  }
};
var F = Object.defineProperty,
  D = Object.getOwnPropertySymbols,
  J = Object.prototype.hasOwnProperty,
  z = Object.prototype.propertyIsEnumerable,
  k = function k(e, t, n) {
    return t in e ? F(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }) : e[t] = n;
  },
  G = function G(e, t) {
    for (var n in t || (t = {})) J.call(t, n) && k(e, n, t[n]);
    if (D) {
      var _iterator = _createForOfIteratorHelper(D(t)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var n = _step.value;
          z.call(t, n) && k(e, n, t[n]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return e;
  };
var P = c.isMobile(),
  g = m({
    wallets: {
      listings: [],
      total: 0,
      page: 1
    },
    injectedWallets: [],
    search: {
      listings: [],
      total: 0,
      page: 1
    },
    recomendedWallets: []
  }),
  ne = {
    state: g,
    getRecomendedWallets: function getRecomendedWallets() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _y$state, e, t, n, _yield$I$getAllListin, s, a, _d$state, _n, _s, _a, r, p, h, _ref, v;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _y$state = y.state, e = _y$state.explorerRecommendedWalletIds, t = _y$state.explorerExcludedWalletIds;
              if (!(e === "NONE" || t === "ALL" && !e)) {
                _context8.next = 3;
                break;
              }
              return _context8.abrupt("return", g.recomendedWallets);
            case 3:
              if (!c.isArray(e)) {
                _context8.next = 13;
                break;
              }
              n = {
                recommendedIds: e.join(",")
              };
              _context8.next = 7;
              return I.getAllListings(n);
            case 7:
              _yield$I$getAllListin = _context8.sent;
              s = _yield$I$getAllListin.listings;
              a = Object.values(s);
              a.sort(function (r, p) {
                var h = e.indexOf(r.id),
                  v = e.indexOf(p.id);
                return h - v;
              }), g.recomendedWallets = a;
              _context8.next = 32;
              break;
            case 13:
              _d$state = d.state;
              _n = _d$state.standaloneChains;
              _s = _d$state.walletConnectVersion;
              _a = _d$state.isAuth;
              r = _n === null || _n === void 0 ? void 0 : _n.join(",");
              p = c.isArray(t);
              h = {
                page: 1,
                sdks: _a ? "auth_v1" : void 0,
                entries: c.RECOMMENDED_WALLET_AMOUNT,
                chains: r,
                version: _s,
                excludedIds: p ? t.join(",") : void 0
              };
              if (!P) {
                _context8.next = 26;
                break;
              }
              _context8.next = 23;
              return I.getMobileListings(h);
            case 23:
              _context8.t0 = _context8.sent;
              _context8.next = 29;
              break;
            case 26:
              _context8.next = 28;
              return I.getDesktopListings(h);
            case 28:
              _context8.t0 = _context8.sent;
            case 29:
              _ref = _context8.t0;
              v = _ref.listings;
              g.recomendedWallets = Object.values(v);
            case 32:
              return _context8.abrupt("return", g.recomendedWallets);
            case 33:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getWallets: function getWallets(e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var t, _y$state2, n, s, a, r, p, _ref2, h, v, j, L;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              t = G({}, e), _y$state2 = y.state, n = _y$state2.explorerRecommendedWalletIds, s = _y$state2.explorerExcludedWalletIds, a = g.recomendedWallets;
              if (!(s === "ALL")) {
                _context9.next = 3;
                break;
              }
              return _context9.abrupt("return", g.wallets);
            case 3:
              t.search || (a.length ? t.excludedIds = a.map(function (W) {
                return W.id;
              }).join(",") : c.isArray(n) && (t.excludedIds = n.join(","))), c.isArray(s) && (t.excludedIds = [t.excludedIds, s].filter(Boolean).join(",")), d.state.isAuth && (t.sdks = "auth_v1");
              r = e.page;
              p = e.search;
              if (!P) {
                _context9.next = 12;
                break;
              }
              _context9.next = 9;
              return I.getMobileListings(t);
            case 9:
              _context9.t0 = _context9.sent;
              _context9.next = 15;
              break;
            case 12:
              _context9.next = 14;
              return I.getDesktopListings(t);
            case 14:
              _context9.t0 = _context9.sent;
            case 15:
              _ref2 = _context9.t0;
              h = _ref2.listings;
              v = _ref2.total;
              j = Object.values(h);
              L = p ? "search" : "wallets";
              return _context9.abrupt("return", (g[L] = {
                listings: [].concat(_toConsumableArray(g[L].listings), j),
                total: v,
                page: r !== null && r !== void 0 ? r : 1
              }, {
                listings: j,
                total: v
              }));
            case 21:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    getInjectedWallets: function getInjectedWallets() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _yield$I$getInjectedL, e, t;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return I.getInjectedListings({});
            case 2:
              _yield$I$getInjectedL = _context10.sent;
              e = _yield$I$getInjectedL.listings;
              t = Object.values(e);
              return _context10.abrupt("return", (g.injectedWallets = t, g.injectedWallets));
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    getWalletImageUrl: function getWalletImageUrl(e) {
      return I.getWalletImageUrl(e);
    },
    getAssetImageUrl: function getAssetImageUrl(e) {
      return I.getAssetImageUrl(e);
    },
    resetSearch: function resetSearch() {
      g.search = {
        listings: [],
        total: 0,
        page: 1
      };
    }
  },
  A = m({
    pairingUri: "",
    pairingError: !1
  }),
  _ = {
    state: A,
    subscribe: function subscribe(e) {
      return f(A, function () {
        return e(A);
      });
    },
    setPairingUri: function setPairingUri(e) {
      A.pairingUri = e;
    },
    setPairingError: function setPairingError(e) {
      A.pairingError = e;
    }
  },
  E = m({
    open: !1
  }),
  se = {
    state: E,
    subscribe: function subscribe(e) {
      return f(E, function () {
        return e(E);
      });
    },
    open: function open(e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", new Promise(function (t) {
                var _d$state2 = d.state,
                  n = _d$state2.isStandalone,
                  s = _d$state2.isUiLoaded,
                  a = _d$state2.isDataLoaded,
                  r = _d$state2.isPreferInjected,
                  p = _d$state2.selectedChain,
                  h = K.state.isConnected,
                  v = y.state.enableNetworkView;
                if (n) d.setStandaloneUri(e === null || e === void 0 ? void 0 : e.uri), d.setStandaloneChains(e === null || e === void 0 ? void 0 : e.standaloneChains), b.reset("ConnectWallet");else if (e != null && e.route) b.reset(e.route);else if (h) b.reset("Account");else if (v) b.reset("SelectNetwork");else if (r) {
                  C.client().connectConnector("injected", p === null || p === void 0 ? void 0 : p.id).catch(function (L) {
                    return console.error(L);
                  }), t();
                  return;
                } else b.reset("ConnectWallet");
                var j = _.state.pairingUri;
                if (s && a && (n || j || h)) E.open = !0, t();else {
                  var L = setInterval(function () {
                    var W = d.state,
                      T = _.state;
                    W.isUiLoaded && W.isDataLoaded && (W.isStandalone || T.pairingUri || h) && (clearInterval(L), E.open = !0, t());
                  }, 200);
                }
              }));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    close: function close() {
      E.open = !1;
    }
  };
var q = Object.defineProperty,
  x = Object.getOwnPropertySymbols,
  Q = Object.prototype.hasOwnProperty,
  X = Object.prototype.propertyIsEnumerable,
  R = function R(e, t, n) {
    return t in e ? q(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }) : e[t] = n;
  },
  Y = function Y(e, t) {
    for (var n in t || (t = {})) Q.call(t, n) && R(e, n, t[n]);
    if (x) {
      var _iterator2 = _createForOfIteratorHelper(x(t)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var n = _step2.value;
          X.call(t, n) && R(e, n, t[n]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    return e;
  };
function Z() {
  return typeof matchMedia < "u" && matchMedia("(prefers-color-scheme: dark)").matches;
}
var S = m({
    themeMode: Z() ? "dark" : "light"
  }),
  ae = {
    state: S,
    subscribe: function subscribe(e) {
      return f(S, function () {
        return e(S);
      });
    },
    setThemeConfig: function setThemeConfig(e) {
      var t = e.themeMode,
        n = e.themeVariables;
      t && (S.themeMode = t), n && (S.themeVariables = Y({}, n));
    }
  },
  w = m({
    open: !1,
    message: "",
    variant: "success"
  }),
  oe = {
    state: w,
    subscribe: function subscribe(e) {
      return f(w, function () {
        return e(w);
      });
    },
    openToast: function openToast(e, t) {
      w.open = !0, w.message = e, w.variant = t;
    },
    closeToast: function closeToast() {
      w.open = !1;
    }
  };
typeof window < "u" && (window.Buffer || (window.Buffer = V), window.global || (window.global = window), window.process || (window.process = {
  env: {}
}));
export { K as AccountCtrl, C as ClientCtrl, y as ConfigCtrl, c as CoreUtil, H as EventsCtrl, ne as ExplorerCtrl, se as ModalCtrl, d as OptionsCtrl, b as RouterCtrl, ae as ThemeCtrl, oe as ToastCtrl, _ as WcConnectionCtrl };